import { useRecoilValue, useResetRecoilState } from "recoil";
import { isLoggedIn } from "api/coachAuth";
import { patientAtom } from "recoil/patientAtom";
import useOpenTask from "./useOpenTask";
import { userAtom } from "../recoil/userAtom";
import useIsRecordSeparatedPage from "./useIsRecordSeparatedPage";
import { selectedThoughtRecordKeyAtom } from "recoil/selectedThoughtRecordAtom";
import { SentimentType } from "../api/thoughtRecordApi";

export default function useOpenThoughtRecord(
  thoughtRecordKey?: string,
  sentiment?: SentimentType
) {
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const user = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);
  const resetSelectedThoughtRecordKey = useResetRecoilState(
    selectedThoughtRecordKeyAtom
  );
  const taskKey = `2-2-T:${patientState?.patientId}`;
  const openTask = useOpenTask({
    taskKey: taskKey,
    thoughtRecordKey: thoughtRecordKey,
    params: sentiment ? { sentiment } : undefined,
  });
  const openThoughtRecordListPage = useOpenTask({ taskKey: "thought-records" });
  const openThoughtRecordDetailPage = useOpenTask({
    taskKey: "thought-record-detail",
    thoughtRecordKey: thoughtRecordKey,
    params: sentiment ? { sentiment } : undefined,
  });

  function addToTabAndOpen() {
    // Reset any previously selected thought record before opening, similar to useOpenNewThoughtRecord
    resetSelectedThoughtRecordKey();

    if (
      isLoggedIn(user) &&
      isRecordSeparatedPage &&
      thoughtRecordKey === undefined
    ) {
      openThoughtRecordListPage();
    } else if (
      isLoggedIn(user) &&
      isRecordSeparatedPage &&
      thoughtRecordKey !== undefined
    ) {
      openThoughtRecordDetailPage();
    } else {
      openTask();
    }
  }

  return addToTabAndOpen;
}
